import type { CoverageDefinition } from '@/features/quotes/types/group-life/coverage-schema.types';

/**
 * Teto de capital a EXIBIR na linha da cobertura ("Max: R$ …").
 *
 * Precedência: o `sumInsuredMax` da API (que além de exibir também trava, via
 * `coverage-resolver`, nos modos de capital digitado) vem primeiro; na
 * ausência dele cai no
 * `sumInsuredMaxDisplay`, que é puramente informativo e injetado a partir do
 * registry de produtos. `null` quando a cobertura não tem teto nenhum.
 */
export function getDisplaySumInsuredMax(
  coverage: Pick<CoverageDefinition, 'sumInsuredMax' | 'sumInsuredMaxDisplay'>
): number | null {
  return coverage.sumInsuredMax ?? coverage.sumInsuredMaxDisplay ?? null;
}
